import React from 'react';
import { IWWTierNode } from '../../../common/model/graphql-types';
import { RatingBox } from '../../../common/components/rating-box';

interface IProps {
  character: IWWTierNode;
}

export const WWPopoverRatings: React.FC<IProps> = ({ character }) => {
  return (
    <>
      <div className="bottom afk-top">
        <RatingBox
          game="hsr"
          rating={character.toa_rating}
          ratingName="Tower of Adversity"
        />
        <RatingBox
          game="hsr"
          rating={character.ww_rating}
          ratingName="Whimpering Wastes"
        />
      </div>
    </>
  );
};
